import React from 'react';
import classnames from 'classnames';
import './styles.scss';

const Input = ({ type = 'text', placeholder, value, onChange }) => {
  return (
    <div className={classnames('cr-input-wrap')}>
      <label>
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      </label>
    </div>
  );
};

export default Input;
